import { Spacer } from 'app/member/layouts/generic';
import { GridColumn, GridRow } from 'app/member/layouts/grid';
import { Button } from 'app/shared/button';
import { DetailItem } from 'app/shared/info-section/item';
import { SimpleInput } from 'app/shared/input';
import { useTenantService } from 'hooks/api/iam/tenant';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';

export const RetentionConfiguration = ({ tenant_id, closeModal = () => {} }) => {
  const { fetchTenant, updateTenant } = useTenantService();

  const [account_duration, setAccountDuration] = useState(365);
  const [data_duration, setDataDuration] = useState(180);
  const [log_duration, setLogDuration] = useState(60);

  useEffect(() => {
    if (!tenant_id) return;

    fetchTenant(tenant_id).then(({ tenant }) => {
      const { retention } = tenant;
      if (!retention) return;

      setAccountDuration(retention.account);
      setDataDuration(retention.data);
      setLogDuration(retention.logs);
    });
  }, [tenant_id]);

  const submit = async () => {
    const data = {
      retention: { account: account_duration, data: data_duration, logs: log_duration }
    };

    if (!tenant_id) return toast.error('Tenant not specified');
    const result = await updateTenant(tenant_id, { data });
    if (!result) return;

    closeModal();
    resetForm();
  };

  const resetForm = () => {
    setAccountDuration(365);
    setDataDuration(180);
    setLogDuration(60);
  };

  return (
    <div>
      <GridRow num_of_columns={1}>
        <GridColumn>
          <DetailItem title="Logs">
            <SimpleInput value={log_duration} type="number" onInput={setLogDuration} />
          </DetailItem>
        </GridColumn>
      </GridRow>
      <GridRow num_of_columns={1}>
        <GridColumn>
          <DetailItem title="Data">
            <SimpleInput value={data_duration} type="number" onInput={setDataDuration} />
          </DetailItem>
        </GridColumn>
      </GridRow>
      <GridRow num_of_columns={1}>
        <GridColumn>
          <DetailItem title="Account">
            <SimpleInput value={account_duration} type="number" onInput={setAccountDuration} />
          </DetailItem>
        </GridColumn>
      </GridRow>
      <Spacer multiple={2} />
      <GridRow num_of_columns={2}>
        <GridColumn />
        <GridColumn>
          <Button text="Save" onClick={submit} />
        </GridColumn>
      </GridRow>
    </div>
  );
};
